<template>
  <div style="background: #fff;overflow: hidden">
    <div>
      <div class="title1">法人认证</div>
    </div>
    <div>
      <div class="idCardBox">
        <div class="idCard1">
          <uploadImg
            class="uploadWrapper"
            v-model="params.legalPersonIdcardSurfaceUrl"
          ></uploadImg>
        </div>
        <div class="idCardText">上传身份证人像面照片</div>
        <div class="idCard2">
          <uploadImg
            class="uploadWrapper"
            v-model="params.legalPersonIdcardEmblemUrl"
          ></uploadImg>
        </div>
        <div class="idCardText">上传身份证国徽面照片</div>
      </div>
      <div class="lineBox flex">
        <div class="title">法人姓名</div>
        <div class="flex1">
          <input
            class="lineInput"
            v-model="params.legalPerson"
            placeholder="请输入法人姓名"
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">身份证号</div>
        <div class="flex1">
          <input
            class="lineInput"
            v-model="params.legalPersonId"
            placeholder="请输入身份证号"
          />
        </div>
      </div>
    </div>
    <div class="addButton" @click="submit">提交认证</div>
  </div>
</template>

<script>
import uploadImg from "@/components/uploadImg/uploadImg";
import { submit } from "../../api/identify";

export default {
  components: {
    uploadImg
  },
  data() {
    return {
      params: {
        legalPersonIdcardSurfaceUrl: "",
        legalPersonIdcardEmblemUrl: "",
        legalPerson: "",
        legalPersonId: "",
        businessLicenseUrl: "",
        companyCode: "",
        companyName: "",
        registeredAddress: ""
      }
    };
  },
  onShow() {},
  created() {
    let that = this;
    const res = this.$ls.get("companyInfo");
    if (res.businessLicenseUrl) {
      that.params.businessLicenseUrl = res.businessLicenseUrl;
    }
    if (res.companyCode) {
      that.params.companyCode = res.companyCode;
    }
    if (res.companyName) {
      that.params.companyName = res.companyName;
    }
    if (res.registeredAddress) {
      that.params.registeredAddress = res.registeredAddress;
    }
  },
  methods: {
    submit() {
      this.$vux.loading.show();
      submit(this.params)
        .then(() => {
          this.$vux.loading.hide();
          this.$ls.remove("companyInfo");
          this.$router.push({ path: "/profile" });
        })
        .catch(err => {
          this.$showError(err);
          this.$vux.loading.hide();
        });
    }
  }
};
</script>

<style lang="less" scoped>
.redTip {
  color: red;
}
.protocol-text {
  display: inline;
}
input {
  width: 100%;
  border: none;
  background: #fff;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.protocol-text {
  display: inline;
}
.inputWapper {
  align-items: center;
  margin: 30px 60px 0 60px;
  border-bottom: 1px solid #e2e2e2;
  padding-bottom: 12px;
  overflow: hidden;
  &.protocol {
    border: none;
    font-size: 12px;
    color: #bfbfbf;
    .protocol-link {
      font-size: 11px;
      color: #007bec;
    }
  }
}
.title1 {
  text-align: center;
  font-size: 20px;
  line-height: 40px;
  padding: 90px 0 40px 0;
  font-weight: bold;
}
.title2 {
  text-align: center;
  font-size: 15px;
  line-height: 30px;
  padding-bottom: 90px;
}
.borderT {
  border-top: 1px solid #e8e8e8;
}
.lineBox {
  margin: 0 50px;
  height: 50px;
  line-height: 50px;
  padding: 24px 16px;
  border-bottom: 1px solid #e8e8e8;
}
.title {
  font-size: 15px;
}
.lineInput {
  height: 50px;
  line-height: 50px;
  text-align: right;
  color: #474747;
  font-size: 14px;
}
.codeButton {
  width: 160px;
  height: 50px;
  line-height: 50px;
  text-align: right;
  font-size: 14px;
  border-left: 1px solid #e8e8e8;
  color: #1573ff;
  margin-left: 20px;
}
.addButton {
  margin: 100px 50px 100px;
  text-align: center;
  font-size: 16px;
  height: 88px;
  line-height: 88px;
  background: #007bec;
  color: #fff;
  border-radius: 10px;
}

.searchBox {
  font-size: 14px;
  padding: 40px;
  height: 64px;
  line-height: 64px;
}
.searchInput {
  height: 64px;
  line-height: 64px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 20px;
  margin-right: 20px;
}
uni-picker-view {
  display: block;
}

uni-picker-view .uni-picker-view-wrapper {
  display: flex;
  position: relative;
  overflow: hidden;
  height: 100%;
  background-color: white;
}

uni-picker-view[hidden] {
  display: none;
}

picker-view {
  width: 100%;
  height: 600px;
  margin-top: 20px;
}
.item {
  line-height: 100px;
  font-size: 16px;
  text-align: center;
}
.uni-padding-wrap {
  padding: 40px;
  font-size: 16px;
}
.uploadImgWrapper {
  margin: 0 50px;
  padding: 24px 16px;
  border-bottom: 1px solid #e8e8e8;
  overflow: hidden;
}
.uploadImgBox {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  margin-left: 60px;
}
.uploadImgBox img {
  width: 100%;
  height: 100%;
}
.idCardBox {
  background: #fff;
  overflow: hidden;
  padding: 60px 0;
}
.idCard1 {
  width: 550px;
  height: 350px;
  background: url(../../assets/idCard1.jpg);
  background-size: 100% 100%;
  display: block;
  margin: 0 auto;
  position: relative;
}
.idCard2 {
  width: 550px;
  height: 350px;
  background: url(../../assets/idCard2.jpg);
  background-size: 100% 100%;
  display: block;
  margin: 0 auto;
  position: relative;
}
.idCardText {
  font-size: 14px;
  color: #ababab;
  text-align: center;
  line-height: 90px;
}
</style>
